/**
 * Filtros globales de Vue para formateo de datos
 */

/**
 * Formatea un número como moneda argentina
 * @param {number|string} value - El valor a formatear
 * @param {object} options - Opciones de formateo
 * @returns {string} - El valor formateado como moneda argentina
 */
export function currency (value, options = {}) {
  if (value == null || value === '') return '$0,00'

  const defaults = {
    prefix: '$',
    thousands: '.',
    decimal: ',',
    precision: 2,
    suffix: ''
  }

  const opts = { ...defaults, ...options }

  // Convertir a número si es string
  const num = typeof value === 'string' ? parseFloat(value) : value

  if (isNaN(num)) return '$0,00'

  // Formatear con la precisión especificada
  const fixed = num.toFixed(opts.precision)
  const parts = fixed.split('.')
  const integer = parts[0]
  const decimal = parts[1]

  // Agregar separador de miles
  const integerWithSeparator = integer.replace(/\B(?=(\d{3})+(?!\d))/g, opts.thousands)

  // Construir el resultado final
  let result = opts.prefix + integerWithSeparator

  if (decimal && opts.precision > 0)
    result += opts.decimal + decimal

  result += opts.suffix

  return result
}

/**
 * Formatea una fecha en formato DD/MM/YYYY
 * @param {string|Date} value - La fecha a formatear
 * @returns {string} - La fecha formateada
 */
export function formatDate (value) {
  if (!value) return ''

  const date = new Date(value)
  if (isNaN(date.getTime())) return ''

  const day = date.getDate().toString().padStart(2, '0')
  const month = (date.getMonth() + 1).toString().padStart(2, '0')
  const year = date.getFullYear()

  return `${day}/${month}/${year}`
}

/**
 * Formatea una fecha y hora en formato DD/MM/YYYY HH:mm
 * @param {string|Date} value - La fecha y hora a formatear
 * @returns {string} - La fecha y hora formateada
 */
export function formatDateTime (value) {
  if (!value) return ''

  const date = new Date(value)
  if (isNaN(date.getTime())) return ''

  const day = date.getDate().toString().padStart(2, '0')
  const month = (date.getMonth() + 1).toString().padStart(2, '0')
  const year = date.getFullYear()
  const hours = date.getHours().toString().padStart(2, '0')
  const minutes = date.getMinutes().toString().padStart(2, '0')

  return `${day}/${month}/${year} ${hours}:${minutes}`
}

/**
 * Formatea una hora en formato HH:mm
 * @param {string|Date} value - La hora a formatear
 * @returns {string} - La hora formateada
 */
export function formatTime (value) {
  if (!value) return ''

  const date = new Date(value)
  if (isNaN(date.getTime())) return ''

  const hours = date.getHours().toString().padStart(2, '0')
  const minutes = date.getMinutes().toString().padStart(2, '0')

  return `${hours}:${minutes}`
}
